import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FrontComponent } from './front.component';
import { TemplatesFrontComponent } from './templates-front/templates-front.component';
import { AnalyticsFrontComponent } from './analytics-front/analytics-front.component';
import { TemplateFrontBuildComponent } from './templates-front/template-front-build/template-front-build.component';
import { TemplateFrontDashboardComponent } from './templates-front/template-front-dashboard/template-front-dashboard.component';
import { TemplateFrontSharedComponent } from './templates-front/template-front-shared/template-front-shared.component';
import { LibraryComponent } from './library/library.component';
import { SettingsComponent } from './settings/settings.component';
import { HelpComponent } from './help/help.component';
import { TrainingVideosComponent } from './help/training-videos/training-videos.component';
import { FaqComponent } from './help/faq/faq.component';
import { SupportComponent } from './help/support/support.component';
import { TemplateFrontArchiveComponent } from './templates-front/template-front-archive/template-front-archive.component';
import { AuthGuard } from '../services/auth-guard.service';
import { AuthBlockGuard } from '../services/auth-block-guard.service';
import { TemplateGroupComponent } from './templates-front/template-front-shared/template-group/template-group.component';
import { TemplateOfficeComponent } from './templates-front/template-front-shared/template-office/template-office.component';
import { TemplateFranchiseComponent } from './templates-front/template-front-shared/template-franchise/template-franchise.component';
import { TemplateAgentSharedComponent } from './templates-front/template-front-shared/template-agent-shared/template-agent-shared.component';
import { MaintenanceGuard } from '../services/maintenance-guard.service';

import { ChangelogsFrontComponent } from './help/changelogs-front/changelogs-front.component';

import { AuthResolver } from '../shared/auth.resolver';
import { TemplateSubgroupComponent } from './templates-front/template-front-shared/template-subgroup/template-subgroup.component';
import { FrontWebsitesComponent } from './front-websites/front-websites.component';
import { FrontContentMarketplaceComponent } from './front-content-marketplace/front-content-marketplace.component';
import { FrontCampaignsComponent } from './front-campaigns/front-campaigns.component';
import { CampaignViewComponent } from './front-campaigns/campaign-view/campaign-view.component';
import { PropertySearchComponent } from '../shared/property-search/property-search.component';

const frontRoutes: Routes = [
  { path: '', component: FrontComponent, canActivate: [AuthGuard, MaintenanceGuard, AuthBlockGuard],  children: [
    { path: '', component: TemplatesFrontComponent },
    { path: 'templates', children: [
      { path: '', component: TemplateFrontDashboardComponent },
      { path: ':id/build', component: TemplateFrontBuildComponent},
    ] },
    { path: 'shared-templates', component: TemplateFrontSharedComponent, children: [
      { path: 'franchise', component: TemplateFranchiseComponent},
      { path: 'groups', component: TemplateGroupComponent},
      { path: 'office', component: TemplateOfficeComponent},
      { path: 'agent', component: TemplateAgentSharedComponent},
      { path: 'subgroup', component: TemplateSubgroupComponent }
      // { path: ':type', component: TemplateFrontSharedComponent},
      // { path: ':type/:gid', component: TemplateFrontSharedComponent},
    ]},
    { path: 'archive-templates', component: TemplateFrontArchiveComponent},
    { path: 'analytics', component: AnalyticsFrontComponent },
    { path: 'library', children: [
      { path: ':type', component: LibraryComponent},
      { path: ':type/:gid', component: LibraryComponent},
    ]},
    { path: 'campaigns', children: [
      { path: '', component: FrontCampaignsComponent },
      { path: ':type/:id/view', component: CampaignViewComponent }
    ] },
    { path: 'settings', component: SettingsComponent },
    { path: 'help', children: [
      { path: '', component: HelpComponent },
      { path: 'training-videos', component: TrainingVideosComponent },
      { path: 'faqs', component: FaqComponent },
      { path: 'support', component: SupportComponent },
      { path: 'changelogs/:group', component: ChangelogsFrontComponent }
    ] },
    { path: 'websites/:type', component: FrontWebsitesComponent },
    { path: 'content/marketplace', component: FrontContentMarketplaceComponent },
    { path: 'test/search', component: PropertySearchComponent }
  ],
  resolve: { front: AuthResolver }
  }
];

@NgModule({
    imports: [RouterModule.forChild(frontRoutes)],
    exports: [RouterModule],
    providers: [ AuthResolver ]
})
export class FrontRouteModule {}



// WEBPACK FOOTER //
// ./src/app/front/front.routing.module.ts